const ar = {
  // Navbar
  "nav.home": "الرئيسية",
  "nav.products": "المنتجات",
  "nav.categories": "الفئات",
  "nav.deals": "العروض",
  "nav.cart": "السلة",
  "nav.wishlist": "المفضلة",
  "nav.account": "الحساب",
  "nav.login": "تسجيل الدخول",
  "nav.register": "إنشاء حساب",
  "nav.logout": "تسجيل الخروج",
  "nav.search_placeholder": "ابحث عن المنتجات...",
  "nav.admin": "الإدارة",

  // Hero
  "hero.trusted_by": "موثوق من قبل أكثر من 50,000 عميل سعيد",
  "hero.title_line1": "اكتشف الجودة",
  "hero.title_line2": "للحياة اليومية",
  "hero.subtitle": "من الضروريات المنزلية إلى أحدث الأجهزة، نقدم لك منتجات مختارة بعناية بأسعار ستحبها. شحن مجاني للطلبات فوق 50 دولارًا.",
  "hero.shop_now": "تسوق الآن",
  "hero.explore": "استكشف العروض",

  // Categories
  "categories.label": "تصفح الفئات",
  "categories.title": "كل ما تحتاجه",
  "categories.subtitle": "استكشف مجموعتنا الواسعة من الفئات، كل منها مليء بمنتجات مختارة يدويًا من أجلك.",

  // Featured Products
  "featured.label": "منتجات مميزة",
  "featured.title": "أفضل اختياراتنا",
  "featured.subtitle": "منتجات مختارة يدويًا يعود عملاؤنا لشرائها مرارًا وتكرارًا.",
  "featured.view_all": "عرض جميع المنتجات",
  "featured.add_to_cart": "أضف إلى السلة",
  "featured.sale": "تخفيض",
  "featured.new": "جديد",

  // Testimonials
  "testimonials.title": "( ماذا يقول عملاؤنا )",
  "testimonials.rating": "تقييم 4.9 من 5",
  "testimonials.review_1": "لقد كنت أتسوق هنا لأكثر من عام والجودة لا تخيب أبدًا. الشحن السريع وخدمة العملاء الرائعة تصنع الفرق.",
  "testimonials.name_1": "سارة ميتشل",
  "testimonials.role_1": "مشتري موثوق",
  "testimonials.review_2": "تنوع المنتجات مذهل. أجد دائمًا ما أحتاجه بالضبط، والأسعار لا تقبل المنافسة مقارنة بالمتاجر الأخرى.",
  "testimonials.name_2": "جيمس رودريغيز",
  "testimonials.role_2": "عميل دائم",

  // CTA
  "cta.title": "مستعد لتطوير نمط حياتك؟",
  "cta.subtitle_line1": "انضم إلى آلاف المتسوقين السعداء واكتشف",
  "cta.subtitle_line2": "منتجات تجعل الحياة اليومية أفضل.",
  "cta.button": "ابدأ التسوق",

  // Newsletter
  "newsletter.title": "ابق على اطلاع",
  "newsletter.subtitle": "اشترك للحصول على عروض حصرية ومنتجات جديدة ونصائح داخلية مباشرة إلى بريدك الإلكتروني.",
  "newsletter.placeholder": "أدخل بريدك الإلكتروني",
  "newsletter.button": "اشتراك",
  "newsletter.success": "شكرًا على الاشتراك! تحقق من بريدك الإلكتروني للحصول على هدية ترحيبية.",
  "newsletter.privacy": "لا بريد مزعج أبدًا. نحن نحترم خصوصيتك.",

  // Footer
  "footer.brand": "جنرال ستور",
  "footer.description": "متجرك الشامل للمنتجات عالية الجودة في جميع الفئات. نؤمن بأن التسوق يجب أن يكون بسيطًا وممتعًا ومجزيًا.",
  "footer.address_title": "العنوان",
  "footer.address_line1": "123 شارع التجارة",
  "footer.address_line2": "نيويورك، NY 10001",
  "footer.phone_title": "الهاتف",
  "footer.phone": "555-234-5678 (1+)",
  "footer.email_title": "البريد الإلكتروني",
  "footer.email": "hello@generalstore.com",
  "footer.shop": "المتجر",
  "footer.company": "الشركة",
  "footer.support": "الدعم",
  "footer.all_products": "جميع المنتجات",
  "footer.new_arrivals": "وصل حديثًا",
  "footer.best_sellers": "الأكثر مبيعًا",
  "footer.deals_footer": "العروض والتخفيضات",
  "footer.about_us": "من نحن",
  "footer.careers": "وظائف",
  "footer.contact": "اتصل بنا",
  "footer.blog": "المدونة",
  "footer.help_center": "مركز المساعدة",
  "footer.shipping": "معلومات الشحن",
  "footer.returns": "الإرجاع والاسترداد",
  "footer.faq": "الأسئلة الشائعة",
  "footer.copyright": "© 2026 جنرال ستور. جميع الحقوق محفوظة.",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الخدمة",
  "footer.cookies": "سياسة ملفات الارتباط",

  // Cart
  "cart.empty": "سلتك فارغة",
  "cart.title": "سلة التسوق",
  "cart.quantity": "الكمية",
  "cart.subtotal": "المجموع الفرعي",
  "cart.checkout": "متابعة الشراء",
  "cart.continue_shopping": "مواصلة التسوق",
  "cart.remove": "إزالة",
  "cart.empty_message": "يبدو أنك لم تضف أي شيء إلى سلتك بعد. ابدأ في استكشاف منتجاتنا واعثر على شيء تحبه!",
  "cart.start_shopping": "ابدأ التسوق",
  "cart.summary": "ملخص الطلب",
  "cart.shipping": "الشحن",
  "cart.free_shipping": "مجاني",
  "cart.total": "الإجمالي",
  "cart.item_count": "{{count}} منتج",
  "cart.item_count_plural": "{{count}} منتجات",
  "cart.coupon_placeholder": "أدخل رمز القسيمة",
  "cart.apply": "تطبيق",
  "cart.added_toast": "تمت الإضافة إلى السلة",
  "cart.save_for_later": "احفظ لوقت لاحق",
  "cart.move_to_cart": "انقل إلى السلة",
  "cart.saved_title": "محفوظ لوقت لاحق",
  "cart.saved_count": "{{count}} منتج محفوظ",
  "cart.saved_count_plural": "{{count}} منتجات محفوظة",
  "cart.saved_empty": "لا توجد منتجات محفوظة",
  "cart.clear_saved": "مسح المحفوظات",

  // Product
  "product.out_of_stock": "نفذ المخزون",
  "product.in_stock": "متوفر",
  "product.add_to_cart": "أضف إلى السلة",
  "product.add_to_wishlist": "أضف إلى المفضلة",
  "product.description": "الوصف",
  "product.reviews": "التقييمات",
  "product.related": "منتجات ذات صلة",
  "product.recently_viewed": "شوهدت مؤخرًا",

  // Auth
  // Auth - Phone
  "auth.welcome_back": "مرحبًا بعودتك",
  "auth.login_subtitle": "أدخل رقم هاتفك لتسجيل الدخول",
  "auth.phone_number": "رقم الهاتف",
  "auth.send_code": "إرسال الرمز",
  "auth.enter_code": "أدخل رمز التحقق",
  "auth.code_sent": "تم إرسال الرمز!",
  "auth.resend_code": "إعادة إرسال الرمز",
  "auth.resend_in": "إعادة الإرسال خلال",
  "auth.didnt_receive": "لم تستلم الرمز؟",
  "auth.wrong_number": "رقم خاطئ؟",
  "auth.change_number": "تغيير الرقم",
  "auth.verifying": "جاري التحقق...",
  "auth.verified": "تم التحقق!",
  "auth.redirecting": "جاري التحويل...",
  "auth.create_account_title": "إنشاء حساب",
  "auth.create_account_subtitle": "أدخل بياناتك للبدء",
  "auth.no_account_phone": "ليس لديك حساب؟",
  "auth.has_account_phone": "لديك حساب بالفعل؟",
  "auth.sign_up": "إنشاء حساب",
  "auth.sign_in": "تسجيل الدخول",
  "auth.full_name": "الاسم الكامل",
  "auth.sign_in_to_continue": "سجل الدخول للمتابعة",
  "auth.please_sign_in": "يجب تسجيل الدخول للوصول إلى هذه الصفحة. يرجى تسجيل الدخول أو إنشاء حساب للمتابعة.",
  "auth.go_to_sign_in": "الذهاب لتسجيل الدخول",

  // Auth - Email fallback
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.forgot_password": "نسيت كلمة المرور؟",
  "auth.no_account": "ليس لديك حساب؟",
  "auth.has_account": "لديك حساب بالفعل؟",
  "auth.confirm_password": "تأكيد كلمة المرور",

  // Checkout
  "checkout.title": "الدفع",
  "checkout.breadcrumb": "الدفع",
  "checkout.shipping_info": "معلومات الشحن",
  "checkout.full_name": "الاسم الكامل",
  "checkout.email": "البريد الإلكتروني",
  "checkout.phone": "رقم الهاتف",
  "checkout.address_line1": "العنوان - السطر الأول",
  "checkout.address_line2": "العنوان - السطر الثاني (اختياري)",
  "checkout.city": "المدينة",
  "checkout.state": "الولاية / المقاطعة",
  "checkout.zip": "الرمز البريدي",
  "checkout.country": "الدولة",
  "checkout.select_country": "اختر الدولة",
  "checkout.order_summary": "ملخص الطلب",
  "checkout.items_count": "{{count}} منتج",
  "checkout.items_count_plural": "{{count}} منتجات",
  "checkout.subtotal": "المجموع الفرعي",
  "checkout.shipping": "الشحن",
  "checkout.free": "مجاني",
  "checkout.tax": "الضريبة (تقديرية)",
  "checkout.total": "الإجمالي",
  "checkout.pay_now": "ادفع الآن",
  "checkout.processing": "جاري معالجة الدفع...",
  "checkout.secure_checkout": "دفع آمن",
  "checkout.ssl_encrypted": "بياناتك محمية بتشفير SSL 256 بت",
  "checkout.back_to_cart": "العودة للسلة",
  "checkout.empty_cart": "سلتك فارغة. أضف بعض المنتجات قبل الدفع.",
  "checkout.field_required": "هذا الحقل مطلوب",
  "checkout.invalid_email": "يرجى إدخال بريد إلكتروني صحيح",
  "checkout.guest_title": "الدفع كزائر",
  "checkout.guest_message": "أنت تدفع الآن كزائر — لا تحتاج لإنشاء حساب. فقط املأ بياناتك أدناه وستكون جاهزًا.",
  "checkout.guest_perk": "هل تريد تتبع الطلبات ودفع أسرع في المرات القادمة؟",
  "checkout.create_account": "إنشاء حساب",

  // Checkout Success
  "success.title": "تم تأكيد الطلب!",
  "success.subtitle": "شكرًا لك على الشراء. تم تقديم طلبك بنجاح.",
  "success.order_number": "رقم الطلب",
  "success.order_date": "تاريخ الطلب",
  "success.estimated_delivery": "التوصيل المتوقع",
  "success.shipping_to": "الشحن إلى",
  "success.payment_method": "طريقة الدفع",
  "success.payment_visa": "فيزا تنتهي بـ 4242",
  "success.confirmation_email": "تم إرسال بريد تأكيد إلى عنوان بريدك الإلكتروني.",
  "success.continue_shopping": "مواصلة التسوق",
  "success.view_order": "عرض الطلب",
  "success.whats_next": "ماذا بعد؟",
  "success.track_info": "ستتلقى معلومات التتبع عبر البريد الإلكتروني بمجرد شحن طلبك.",
  "success.questions": "هل لديك أي أسئلة؟ اتصل بفريق الدعم.",
  "success.contact_support": "اتصل بالدعم",

  // Account
  "account.my_account": "حسابي",
  "account.orders": "طلباتي",
  "account.wishlist": "المفضلة",
  "account.settings": "الإعدادات",
  "account.order_history": "سجل الطلبات",
  "account.dashboard": "لوحة المعلومات",
  "account.welcome_back": "مرحبًا بعودتك",
  "account.total_orders": "إجمالي الطلبات",
  "account.total_spent": "إجمالي الإنفاق",
  "account.wishlist_count": "المفضلة",
  "account.recent_orders": "أحدث الطلبات",
  "account.view_all_orders": "عرض جميع الطلبات",
  "account.no_orders": "لا توجد طلبات بعد",
  "account.no_orders_desc": "لم تقم بأي طلبات بعد. ابدأ التسوق وستظهر طلباتك هنا.",
  "account.start_shopping": "ابدأ التسوق",
  "account.order_number": "الطلب",
  "account.order_date": "التاريخ",
  "account.order_status": "الحالة",
  "account.order_total": "الإجمالي",
  "account.order_details": "تفاصيل الطلب",
  "account.back_to_orders": "العودة للطلبات",
  "account.order_summary": "ملخص الطلب",
  "account.shipping_address": "عنوان الشحن",
  "account.payment_method": "طريقة الدفع",
  "account.tracking_number": "رقم التتبع",
  "account.estimated_delivery": "التوصيل المتوقع",
  "account.subtotal": "المجموع الفرعي",
  "account.shipping": "الشحن",
  "account.tax": "الضريبة",
  "account.item": "منتج",
  "account.items": "منتجات",
  "account.order_placed": "تم تقديم الطلب",
  "account.track_order": "تتبع الطلب",
  "account.buy_again": "شراء مرة أخرى",
  "account.reorder": "إعادة طلب المنتجات",
  "account.reorder_success": "تمت إضافة جميع المنتجات إلى السلة!",
  "account.reorder_partial": "تمت إضافة {{count}} منتج إلى السلة ({{skipped}} غير متوفر)",
  "account.empty_wishlist": "قائمة المفضلة فارغة",
  "account.empty_wishlist_desc": "احفظ منتجاتك المفضلة بالنقر على أيقونة القلب على أي منتج. ستظهر هنا.",
  "account.browse_products": "تصفح المنتجات",
  "account.remove_from_wishlist": "إزالة",
  "account.added": "أضيف",
  "account.settings_title": "إعدادات الحساب",
  "account.settings_subtitle": "إدارة معلوماتك الشخصية وتفضيلاتك",
  "account.profile_info": "المعلومات الشخصية",
  "account.preferences": "التفضيلات",
  "account.full_name_label": "الاسم الكامل",
  "account.phone_label": "رقم الهاتف",
  "account.email_label": "البريد الإلكتروني",
  "account.email_placeholder": "بريدك@example.com",
  "account.save_changes": "حفظ التغييرات",
  "account.saved": "تم حفظ التغييرات بنجاح!",
  "account.language_pref": "تفضيل اللغة",
  "account.currency": "العملة",
  "account.email_notifications": "إشعارات البريد الإلكتروني",
  "account.order_updates": "تحديثات الطلبات",
  "account.promotions": "العروض والتخفيضات",
  "account.newsletter": "النشرة الأسبوعية",
  "account.danger_zone": "منطقة الخطر",
  "account.delete_account": "حذف الحساب",
  "account.delete_warning": "بمجرد حذف حسابك، لا يمكن التراجع. يرجى التأكد.",
  "account.delete_button": "حذف حسابي",

  // Products - Filters
  "products.filters": "التصفية",
  "products.filters_count": "فلتر {{count}}",
  "products.filters_count_plural": "{{count}} فلاتر",
  "products.show_results": "عرض {{count}} نتيجة",
  "products.sort_by": "ترتيب حسب",
  "products.sort_newest": "الأحدث",
  "products.sort_price_low": "السعر: من الأقل للأعلى",
  "products.sort_price_high": "السعر: من الأعلى للأقل",
  "products.sort_rating": "الأعلى تقييمًا",
  "products.search_label": "بحث",
  "products.category_label": "الفئات",
  "products.price_label": "نطاق السعر",
  "products.rating_label": "الحد الأدنى للتقييم",
  "products.rating_and_up": "وأعلى",
  "products.in_stock_only": "المتوفر فقط",
  "products.clear_all": "مسح جميع الفلاتر",
  "products.no_products": "لم يتم العثور على منتجات",
  "products.no_products_desc": "جرب تعديل الفلاتر أو مصطلحات البحث",
  "products.results_count": "تم العثور على {{count}} منتج",
  "products.results_count_plural": "تم العثور على {{count}} منتج",
  "products.tag_price": "${{min}} — ${{max}}",
  "products.quick_view": "نظرة سريعة",
  "products.view_full_details": "عرض التفاصيل الكاملة",
  "products.close": "إغلاق",
  "products.load_more": "تحميل المزيد من المنتجات",
  "products.showing_count": "عرض {{shown}} من {{total}} منتج",

  // Admin
  "admin.dashboard": "لوحة التحكم",
  "admin.products": "المنتجات",
  "admin.orders": "الطلبات",
  "admin.customers": "العملاء",
  "admin.analytics": "التحليلات",
  "admin.add_product": "إضافة منتج",
  "admin.edit_product": "تعديل المنتج",
  "admin.delete_product": "حذف المنتج",
  "admin.update_status": "تحديث الحالة",
  "admin.total_revenue": "إجمالي الإيرادات",
  "admin.recent_orders": "أحدث الطلبات",
  "admin.view_all": "عرض الكل",
  "admin.search_placeholder": "بحث...",
  "admin.all_categories": "جميع الفئات",
  "admin.all_status": "جميع الحالات",
  "admin.in_stock": "متوفر",
  "admin.out_of_stock": "نفذ المخزون",
  "admin.save_changes": "حفظ التغييرات",
  "admin.cancel": "إلغاء",
  "admin.confirm_delete": "حذف المنتج",
  "admin.confirm_delete_message": "هل أنت متأكد من حذف",
  "admin.no_products": "لا توجد منتجات تطابق الفلاتر",
  "admin.no_orders": "لم يتم العثور على طلبات",
  "admin.no_customers": "لا يوجد عملاء يطابقون البحث",
  "admin.customer_since": "عميل منذ",

  // General
  "general.loading": "جاري التحميل...",
  "general.error": "حدث خطأ ما",
  "general.retry": "حاول مرة أخرى",
  "general.view_all": "عرض الكل",
  "general.no_results": "لم يتم العثور على نتائج",
  "general.scroll_to_top": "العودة للأعلى",

  // Language
  "language.en": "English",
  "language.ar": "العربية",
};

export default ar;